import React, { useEffect, useRef, useState } from 'react';
import { useUsers } from '../hooks/useUsers';
import { useAppDate } from '../context/AppContext';
import { Chat, useChats } from '../hooks/useChats';
import { useChatMessages } from '../hooks/useChatMessages';
import { MessageReceivePayload, MessageSendPayload, MessageType } from '../datatypes';


function SciChat() {
  const { chats, setChats, getChat } = useChats();
  const { fetchMessages } = useChatMessages();

  const chatsRef = useRef<Chat[]>(chats);
  const chatMessagesRef = useRef<{[chatId: string]: MessageReceivePayload[]}>({});  
  const newChatMessagesRef = useRef<{[chatId: string]: boolean}>({});  
  const selectedChatRef = useRef<Chat | null>(null);

  const  { socketRef, userEmail } = useAppDate();
  const [chatMessages, setChatMessages] = useState<{[chatId: string]: MessageReceivePayload[]}>({});  
  const [newChatMessages, setNewChatMessages] = useState<{[chatId: string]: boolean}>({});  
  const [selectedChat, setSelectedChat] = useState<Chat | null>(null);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [otherTyping, setOtherTyping] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement | null>(null);


  useEffect(() => {
    chatsRef.current = chats;
  }, [chats]);

  useEffect(()=> {
    selectedChatRef.current = selectedChat;
  }, [selectedChat])

  useEffect(() => {
    chatsRef.current = chats;
  }, [chats]);

  useEffect(() => {
    chatMessagesRef.current = chatMessages;
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatMessages]);

  useEffect(() => {
    if(socketRef.current) {
      socketRef.current.on('message:receive', (payload: MessageReceivePayload) => {        
        if(payload.chat.id){         
          if(chatMessagesRef.current[payload.chat.id]){
            chatMessagesRef.current[payload.chat.id] = [...chatMessagesRef.current[payload.chat.id]?.filter(p => p.content !== payload.content), payload]
          }else{
            chatMessagesRef.current[payload.chat.id] = [payload];            
            onNewChat(payload.chat.id);
            console.log(payload.chat.id, "new chat")
          }          
          setChatMessages({...chatMessagesRef.current});     
          handNotifycation(payload.chat.id, true);   
        }
      });
      socketRef.current.on('user:typing', (payload: any) => {
        console.log('User typing:', payload);
        if (payload.userId !== userEmail) {
          setOtherTyping(payload.isTyping);
        }
      });
    }
  }, [userEmail,socketRef]);


  const handNotifycation = (chatId: string, shoudNotify: boolean) => {
    if (shoudNotify) {
      if(selectedChatRef.current?.id !== chatId){
        newChatMessagesRef.current[chatId] = true;
        setNewChatMessages({ ...newChatMessagesRef.current });
      }
    } else {
      delete newChatMessagesRef.current[chatId];
      setNewChatMessages({ ...newChatMessagesRef.current });
    }
  }


  const onNewChat = (chatId: string) => {
    getChat(chatId)
      .then(chat => {
        if(chat){
          if (chat) {
            const exists = chatsRef.current.some(c => c.id === chat.id);
            if (!exists) {
              const updatedChats = [chat,...chatsRef.current];
              setChats(updatedChats);
            }
            if (exists) { 
            const filtered = chatsRef.current.filter((item) => item.id !== chat.id);          
              const updatedChats = [chat,...filtered];
              setChats(updatedChats);
            }
          }
        }        
      })
  }

  const handleSend = () => {
    if (input.trim() && socketRef.current && userEmail) {
      const msg: MessageSendPayload = {
        senderId: userEmail,
        content: input,        
        chatId: selectedChat?.id,
        type: MessageType.text
      };
      socketRef.current.emit('message:send', msg);
      // setMessages((prev) => [...prev, msg]);
      setInput('');
      setIsTyping(false);
      socketRef.current.emit('user:typing', { userId: userEmail, isTyping: false });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value);
    if (!isTyping && socketRef.current) {
      setIsTyping(true);
      // socketRef.current.emit('user:typing', { userId: userEmail, isTyping: true });
    }
    if (isTyping && e.target.value === '' && socketRef.current) {
      setIsTyping(false);
      // socketRef.current.emit('user:typing', { userId: userEmail, isTyping: false });
    }
  };

  const checkMessages = (chat: Chat) => {
    fetchMessages(chat.id)
      .then(messages => {
        if (messages) {
          chatMessages[chat.id] = messages;
          setChatMessages({ ...chatMessages });
        }
      }).catch(err => {
        console.error('Error fetching messages:', err);
      })
  };

  const getChatTitle = (chat: Chat) => {
    const members = getChatMembers(chat);    
    return members?.map(m => m.user.name).join(', ');
  }

  const getChatMembers = (chat: Chat) => {
    const members = chat.members?.filter(cm => !cm.user?.isSciUser);
    return members;   
  }

  const getemailWithdeis = (chat: any) => {
      if(chat.user.country){
        if(chat.user.name=="Anonymous"){
          return chat.user.email +" - "+chat.user.country
        }
        else{
          return chat.user.name +" - "+chat.user.country
        }
      }
      else return chat.user.email;       
  }


  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <aside className="w-80 bg-white border-r flex flex-col p-4 overflow-y-auto">
        <h2 className="text-lg font-bold mb-4">Chats</h2>
        <ul className="space-y-3">
          {chats && chats.length > 0 ? (
            chats.map((chat: Chat) => (
              <li
                key={chat.id}
                className={`flex items-center space-x-3 cursor-pointer rounded-2xl p-3 transition-all duration-200 shadow-sm border border-gray-200 bg-white/80 hover:scale-105 hover:shadow-lg hover:bg-gradient-to-br hover:from-blue-50 hover:to-green-50 relative ${selectedChat?.id === chat.id ? 'ring-1 ring-blue-300 border-blue-200 bg-gradient-to-br from-blue-50 to-green-50 scale-105 shadow-md' : ''}`}
                onClick={() => {                  
                  setSelectedChat(chat);
                  checkMessages(chat);
                  handNotifycation(chat.id, false);
                }}
                title={getChatTitle(chat)}
                style={{ animation: 'fadeIn 0.3s' }}
              >
                {/* Notification icon */}
                {newChatMessages[chat.id] && <div className="absolute top-2 right-2 w-3 h-3 bg-red-500 rounded-full animate-pulse shadow-sm"></div>}
                
                {/* Avatar with initials */}
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gradient-to-br from-blue-400 to-green-600 text-white font-bold text-lg shadow-md">
                  {chat.members && chat.members.length > 0
                    ? getChatMembers(chat).map(m => m.userId?.[0]?.toUpperCase() || '?').join('')
                    : '?'}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap gap-1">
                    {chat.members && chat.members.length > 0
                      ? getChatMembers(chat).map(m => (
                          <span
                            key={m.userId}
                            className="inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-1 rounded-full border border-blue-300 shadow-sm"
                          >
                            {getemailWithdeis(m) }
                          </span>
                        ))
                      : <span className="text-gray-400 text-xs">No members</span>
                      }     
                    <span
                      key={chat.tool}
                      className="inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-1 rounded-full border border-blue-300 shadow-sm"
                    >
                      {chat.tool?.toUpperCase()}
                    </span>                 
                  </div>
                </div>
              </li>
            ))
          ) : (
            <li className="text-gray-400 text-sm">No chats</li>
          )}
        </ul>
      </aside>

      
      {/* Main Chat Area */}
      <div className="flex-1 flex flex-col h-full">
        <div className="flex-1 overflow-y-auto p-4 max-h-[calc(100vh-80px)] relative" style={{
          backgroundImage: `url('data:image/svg+xml;utf8,<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"120\" height=\"120\" fill=\"%23f3f4f6\"/><path d=\"M0 60 Q30 90 60 60 T120 60\" stroke=\"%239ca3af\" stroke-width=\"1.5\" fill=\"none\" opacity=\"0.18\"/><path d=\"M0 80 Q40 100 80 80 T120 80\" stroke=\"%236b7280\" stroke-width=\"1.2\" fill=\"none\" opacity=\"0.13\"/><ellipse cx=\"40\" cy=\"40\" rx=\"10\" ry=\"18\" fill=\"%239ca3af\" fill-opacity=\"0.08\"/><ellipse cx=\"90\" cy=\"90\" rx=\"14\" ry=\"8\" fill=\"%236b7280\" fill-opacity=\"0.10\"/><!-- Tree icon --><g opacity=\"0.18\"><rect x=\"20\" y=\"90\" width=\"4\" height=\"10\" fill=\"%236b7280\"/><polygon points=\"22,90 16,100 28,100\" fill=\"%239ca3af\"/></g><!-- Car icon --><g opacity=\"0.18\"><rect x=\"70\" y=\"100\" width=\"18\" height=\"6\" rx=\"2\" fill=\"%239ca3af\"/><rect x=\"72\" y=\"98\" width=\"14\" height=\"4\" rx=\"1\" fill=\"%236b7280\"/><circle cx=\"74\" cy=\"108\" r=\"2\" fill=\"%236b7280\"/><circle cx=\"86\" cy=\"108\" r=\"2\" fill=\"%236b7280\"/></g></svg>')`,
          backgroundRepeat: 'repeat',
          backgroundSize: 'auto',
        }}>
          {/* Blur overlay for area outside message area */}
          {/* Message area with solid background to remain sharp */}
          {(selectedChat && chatMessages) && <div className="relative z-10 max-w-xl mx-auto space-y-4 rounded-xl bg-white bg-opacity-80 p-2 min-h-[calc(100vh-20px)]">
            {chatMessages[selectedChat.id]?.map((msg, idx) => (
              <div
                key={msg.timestamp.toString() + idx}
                className={`flex transition-all duration-200 ${msg.senderId === userEmail ? 'justify-end' : 'justify-start'}`}
              >
                <div
                  className={`relative group rounded-2xl px-5 py-3 shadow-lg text-sm max-w-xs break-words border transition-all duration-200
                    ${msg.senderId === userEmail
                      ? 'bg-gradient-to-br from-blue-400 to-green-600 text-white border-blue-300 shadow-blue-200'
                      : 'bg-white text-gray-800 border-gray-200 shadow-gray-200'}
                    hover:scale-105 hover:shadow-xl
                  `}
                  style={{ animation: 'fadeIn 0.3s' }}
                >
                  {/* Show sender name for messages not from current user */}
                  {msg.senderId !== userEmail && (
                    <div className="text-[10px] font-semibold text-gray-600 mb-1">
                       { msg.senderName && msg.senderName !== 'Anonymous' ? msg.senderName : msg.senderId}
                    </div>
                  )}
                  <span>{msg.content}</span>
                  <div className="text-[10px] text-right opacity-60 mt-1">
                    {new Date(msg.timestamp).toLocaleDateString()} {new Date(msg.timestamp).toLocaleTimeString()}
                  </div>
                  {/* Optional: Add a small triangle for the bubble */}
                  <span className={`absolute bottom-0 ${msg.senderId === userEmail ? 'right-0' : 'left-0'} w-0 h-0 border-t-8 border-t-transparent border-b-0 border-b-transparent ${msg.senderId === userEmail ? 'border-l-8 border-l-green-600' : 'border-r-8 border-r-white'}`}></span>
                </div>
              </div>
            ))}
            <div ref={messagesEndRef} />
            {otherTyping && (
              <div className="text-xs text-gray-500 mt-2 animate-pulse">Someone is typing...</div>
            )}
          </div>}
        </div>
        <div className="p-4 bg-white border-t flex items-center max-w-xl mx-auto w-full sticky bottom-0 z-10">
          <input
            className="flex-1 border rounded px-3 py-2 mr-2 focus:outline-none focus:ring"
            type="text"
            value={input}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSend();
            }}
            placeholder="Type your message..."
          />
          <button
            className="bg-green-400  px-4 py-2 rounded disabled:opacity-50"
            onClick={handleSend}
            disabled={!input.trim()}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
}

export default SciChat;



